var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "justify-content": "space-between" } },
    [
      _c(
        "el-checkbox",
        {
          staticStyle: { "line-height": "28px", "margin-right": "2px" },
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.expressChangeHandler },
          model: {
            value: _vm.job.express,
            callback: function($$v) {
              _vm.$set(_vm.job, "express", $$v)
            },
            expression: "job.express"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
      ),
      _vm.job.express
        ? _c("el-input", {
            attrs: { disabled: _vm.disabled },
            on: {
              change: function($event) {
                return _vm.onChange("mbl")
              }
            },
            model: {
              value: _vm.job.mbl,
              callback: function($$v) {
                _vm.$set(_vm.job, "mbl", $$v)
              },
              expression: "job.mbl"
            }
          })
        : _vm._e(),
      _c("mawb-no-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.job.express,
            expression: "!job.express"
          }
        ],
        attrs: { editable: _vm.disabled || _vm.isEditablemawbNoInput },
        on: {
          change: function($event) {
            return _vm.onChange("mbl")
          }
        },
        model: {
          value: _vm.job.mbl,
          callback: function($$v) {
            _vm.$set(_vm.job, "mbl", $$v)
          },
          expression: "job.mbl"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }